import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import AccessibleDropdown from 'common/AccessibleDropdown';
import { isEmptyString } from 'utils/text';
import css from './ServiceCardFooterOptions.scss';
import { getServiceURL, getScheduleServiceURL } from '../../../utils/deepLinks';
import copy from 'clipboard-copy';
import Toast from 'common/Toast';
import { getTenantConfig } from 'utils/tenant';
import {getVirtualKioskLink} from "utils/kiosk";

const ServiceCardFooterOptions = props => {

  const [showToast, setShowToast] = useState(false);

  const copyProfileLink = async () => {
    try {
      await copy(getServiceURL(props.serviceId));
      setShowToast(true);
    } catch (e) {
      console.warn(e);
    }
  }

  const copyAppointmentLink = async () => {
    try {
      await copy(getScheduleServiceURL(props.serviceId));
      setShowToast(true);
    } catch (e) {
      console.warn(e);
    }
  }

  const showLinksOptions = (
    getTenantConfig('DEEP_LINKS_ENABLED') // Deep links must be enabled
    && !!getTenantConfig('DEEP_LINK_SSO_METHOD') // Needs to have a SSO method set
    && props.isStaff // Only staff should see the links options
  );

  const getWaitingRoomLinkText =
      props.checkedIntoService ?
          (props.virtualCheckInOpen ? "Check out of Waiting Room" : "Check Out Unavailable")
          : (props.virtualCheckInOpen ? "Join Virtual Waiting Room" : "Waiting Room Closed")

  const options = [];
  if ( props.isStudent && props.virtualCheckInEnabled ) {
    options.push({
      key: "key_0",
      as: "a",
      title: props.virtualCheckInOpen ? null : "Virtual check-in not available. Click on the Service for check-in hours.",
      text: getWaitingRoomLinkText,
      value: getVirtualKioskLink(props.kioskId, props.serviceId),
      disabled: !props.virtualCheckInOpen
    });
  }

  if ( !isEmptyString(props.email) ) {
    options.push({
      key: "key_1",
      as: 'a',
      value: `mailto:${props.email.trim()}`,
      text: "Email"
    });
  }

  if ( !isEmptyString(props.url) ) {
    options.push({
      key: "key_2",
      as: 'a',
      value: props.url.trim(),
      text: "Visit website"
    });
  }

  options.push({
    key: "key_3",
    as: 'a',
    value: `../instructor/serviceCatalog.html#service/${props.serviceId}`,
    text: "View Profile"
  });

  if ( showLinksOptions ) {
    options.push({
      key: "key_4",
      text: "Copy Profile Link",
      value: "Copy Profile Link"
    });
  
    // Only services with calendar enabled should display the copy appointment link
    if ( props.serviceCalendarEnabled ) {
      options.push({
        key: "key_5",
        text: "Copy Appointment Link",
        value: "Copy Appointment Link",
      });
    }
  }

  return (
    <>
      <AccessibleDropdown
        icon ='ellipsis horizontal'
        id={props.serviceId}
        value={false}
        upward={props.upward}
        className={css['item-dropdown']}
        aria-label={props.serviceName}
        options={options}
        selectOnBlur={false}
        selectOnNavigation={false}
        openOnFocus={false}
        onChange={(e, { value }) => {
          if ( value === "Copy Profile Link" ) copyProfileLink();
          else if ( value === "Copy Appointment Link" ) copyAppointmentLink();
          else if ( value === props.url.trim() ) window.open(value); // open the url in new tab
          else window.location.assign(value);
        }}
      />
      {showToast && <Toast message={"Link copied to your clipboard."} onTimeout={() => setShowToast(false)} />}
    </>
  );
}

ServiceCardFooterOptions.propTypes = {
  serviceId: SFEntityID.isRequired,
  serviceName: PropTypes.string.isRequired,
  email: PropTypes.string,
  url: PropTypes.string,
  isStaff: PropTypes.bool.isRequired,
  isStudent: PropTypes.bool.isRequired,
  serviceCalendarEnabled: PropTypes.bool,
  upward: PropTypes.bool,
  kioskId: PropTypes.number,
  virtualCheckInEnabled: PropTypes.bool,
  checkedIntoService: PropTypes.bool,
  virtualCheckInOpen: PropTypes.bool
};

export default ServiceCardFooterOptions;
